import type { OarTaskContent } from '../types/oar-types';

/**
 * OAR 数据加载器接口
 *
 * 每个 Loader 负责加载 OarTaskContent 的一部分数据
 * 符合开闭原则：新增数据源只需实现此接口并注册到 DI 容器
 */
export interface OarTaskDataLoader {
    /** 加载器名称（用于日志和调试） */
    readonly name: string;

    /**
     * 是否应该执行加载
     *
     * 根据当前状态判断是否需要加载数据
     * 例如：检查 parseStatus 是否为 SUCCESS
     *
     * @param state - 当前 OAR 任务内容状态
     * @returns 是否应该执行加载
     */
    shouldLoad(state: OarTaskContent): boolean;

    /**
     * 执行加载
     *
     * 调用相应的 API 获取数据
     *
     * @param taskId - 任务 ID
     * @returns 要更新到 Model 的部分状态
     */
    load(taskId: string): Promise<Partial<OarTaskContent>>;
}

/**
 * OarTaskDataLoader 的 DI Symbol
 */
export const OarTaskDataLoader = Symbol('OarTaskDataLoader');
